import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithReauth } from "utils/baseQueryWithReauth";
import { OrganizationResponse, VendorResponse } from "../types/types";

const baseOrganizationsQuery = createBaseQueryWithReauth({
  baseUrl: process.env.REACT_APP_UAT_ORGANIZATIONS_API_URL || '',
});

export const organizationsApiSlice = createApi({
  reducerPath: 'organizationsApi',
  baseQuery: baseOrganizationsQuery,
  endpoints: (builder) => ({
    getOrganizations: builder.query<OrganizationResponse[], void>({
      query: () => '/Organizations',
    }),
    getVendorsByVendorName: builder.query<VendorResponse, { vendorName: string }>({
      query: (data) => ({
        url: `/Vendors/${encodeURIComponent(data.vendorName)}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetOrganizationsQuery, useGetVendorsByVendorNameQuery, useLazyGetOrganizationsQuery, useLazyGetVendorsByVendorNameQuery } = organizationsApiSlice;